<template>
  <div class="clear">
    <div class="tar">
      <a @click="run" class="fa fz16 fa-play mgr10" title="运行"></a>
      <a-dropdown>
        <span class="fa fz16 fa-wrench" title="语法检测"></span>
        <a-menu slot="overlay">
          <a-menu-item>
            <a @click="checkSql" href="javascript:;">语法检测</a>
          </a-menu-item>
          <a-menu-item>
            <a @click="formatSql" href="javascript:;">格式化</a>
          </a-menu-item>
          <a-menu-item>
            <a @click="clearAll" href="javascript:;">清空</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <b-ace-editor :readonly="disabled" :snippets="true" :value="value" :height="height" @input="$emit('input', $event)" lang="sql"> </b-ace-editor>
    <a-alert v-if="showError" :message="msg" type="error" closable @close="onClose" />
  </div>
</template>
<script>
import Vue from 'vue';
import Editor from 'bin-ace-editor';
import { format, precheck } from '@/services/sql';
require('brace/ext/language_tools');
require('brace/mode/sql');
require('brace/snippets/sql');
require('brace/theme/chrome');
Vue.component(Editor.name, Editor);
export default {
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '160'
    }
  },
  data() {
    return {
      showError: false
    };
  },
  methods: {
    async formatSql() {
      let res = await format(this.value);
      if (res) {
        this.$emit('input', res.payload);
      }
    },
    clearAll() {
      this.$emit('input', '');
      this.showError = false;
      this.$emit('clear');
    },
    async checkSql() {
      this.showError = false;
      this.msg = '';
      let res = await precheck(this.value);
      let { header } = res;
      if (header.code == 500) {
        this.showError = true;
        this.msg = header.msg;
      } else {
        this.$message.success('语法正确');
      }
    },
    onClose() {
      this.showError = false;
    },
    run() {
      this.$emit('run');
    }
  }
};
</script>
<style lang="less">
.clear {
  clear: both;
}
</style>
